var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5C12.2956 5 13.0587 5.31607 13.6213 5.87868C14.1839 6.44129 14.5 7.20435 14.5 8C14.5 8.79565 14.1839 9.55871 13.6213 10.1213C13.0587 10.6839 12.2956 11 11.5 11C10.7044 11 9.94129 10.6839 9.37868 10.1213C8.81607 9.55871 8.5 8.79565 8.5 8C8.5 7.20435 8.81607 6.44129 9.37868 5.87868C9.94129 5.31607 10.7044 5 11.5 5ZM11.5 0.5C16.5 0.5 20.77 3.61 22.5 8C20.77 12.39 16.5 15.5 11.5 15.5C6.5 15.5 2.23 12.39 0.5 8C2.23 3.61 6.5 0.5 11.5 0.5ZM2.68 8C4.33 11.36 7.74 13.5 11.5 13.5C15.26 13.5 18.67 11.36 20.32 8C18.67 4.64 15.26 2.5 11.5 2.5C7.74 2.5 4.33 4.64 2.68 8Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.d5faa5015db8159c0bad3084f5cedced.svg";
export { ForwardRef as ReactComponent };